import { FC } from 'react';

/**
 * LoadingOverlay component to display a loading spinner overlay.
 * Centered horizontally and vertically over the full viewport.
 */
const LoadingOverlay: FC = () => (
  <div className="loading-overlay">
    <div className="loading-overlay__wrapper">
      <span className="loading-overlay__spinner" role="status" aria-busy="true"></span>
    </div>
  </div>
);

export default LoadingOverlay;
